/**
 * Class de configuration
 */
export class AsiDialogConfig {
  /** Add a class to the dialog */
  class?: string;
  /** This dialog is over another dialog */
  over?: boolean;
  /** Drop the dialog when click outside */
  outsideDrop?: boolean;
}
